/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : EMBED QUESTION FORMAT : STYLES --------------- ++++++++++ */
export default theme => ({
	questionformat: {
		cursor: 'pointer',
		display: 'block',
		'&:hover': {
			'& .desc': {
				'& .text': {
					color: theme.color.primary.medium.swatch
				}
			}
		},
		'&:nth-child(1)': { marginTop: '0' },
		'&:nth-child(2)': { marginTop: '0' },
		'& .visual': {
			backgroundColor: 'transparent',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '50%',
			backgroundSize: 'contain',
			width: pxToEm(80),
			height: pxToEm(80),
			marginBottom: pxToEm(10)
		},
		'& .desc': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			'& .icon': {
				backgroundColor: 'transparent',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: '50%',
				backgroundSize: 'contain',
				width: pxToEm(20),
				height: pxToEm(20),
				marginRight: pxToEm(8)
			},
			'& .text': {
				transition: 'all .2s linear 0s',
				extend: theme.typography.size.small
			}
		},
		'&.active': {
			'& .text': {
				color: theme.color.primary.medium.swatch
			}
		},
		'&.emoji': {
			'& .visual': { backgroundImage: `url(${url.image}/embed-layout-emoji-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image}/embed-layout-emoji-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image}/embed-layout-emoji-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image}/embed-layout-emoji-icon-default.png)` }
			}
		},
		'&.image1': {
			'& .visual': { backgroundImage: `url(${url.image}/embed-layout-round-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image}/embed-layout-round-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image}/embed-layout-round-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image}/embed-layout-round-icon-active.png)` }
			}
		},
		'&.image2': {
			'& .visual': { backgroundImage: `url(${url.image}/embed-layout-large-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image}/embed-layout-large-icon-default.png)`, height: `${pxToEm(24)} !important` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image}/embed-layout-large-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image}/embed-layout-large-icon-active.png)` }
			}
		},
        '&.text1': {
            '& .visual': { backgroundImage: `url(${url.image}/embed-layout-text-poll-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image}/embed-layout-text-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image}/embed-layout-text-poll-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image}/embed-layout-text-icon-active.png)` }
			}
        },
        '&.text2': {
			'& .visual': { backgroundImage: `url(${url.image}/embed-layout-text-full-pic-inactive.png)` },
			'& .icon': { backgroundImage: `url(${url.image}/embed-layout-text-icon-default.png)` },
			'&.active': {
				'& .visual': { backgroundImage: `url(${url.image}/embed-layout-text-full-pic-active.png)` },
				'& .icon': { backgroundImage: `url(${url.image}/embed-layout-text-icon-active.png)` }
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: {
		questionformat: {
			margin: 0
		}
	},
});
